import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import Nav from './components/Nav';
import Footer from './components/Footer';
import AnimatedBackground from './components/AnimatedBackground';
import Home from './pages/Home';
import About from './pages/About';
import Races from './pages/Races';
import Community from './pages/Community';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-gray-900 relative">
          <AnimatedBackground />
          <Nav />
          <div className="pt-16 flex flex-col min-h-screen relative z-10">
            <div className="flex-grow">
              <Routes>
                <Route
                  path="/"
                  element={<Home />}
                />
                <Route
                  path="/about"
                  element={<About />}
                />
                <Route
                  path="/races"
                  element={<Races />}
                />
                <Route
                  path="/community"
                  element={<Community />}
                />
              </Routes>
            </div>
            <Footer />
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
